/* eslint-disable complexity, no-console, brace-style */
import { useState, useEffect } from 'react'

export function useJobsData(areaConfig) {
    const [jobs, setJobs] = useState([])
    const [mapping, setMapping] = useState({
        areaMapping: {},
        genreMapping: {},
        positionMapping: {}
    })
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        async function loadJobs() {
            try {
                setLoading(true)
                setError(null)
                
                let area = 'kanto'
                
                // 福岡エリアの場合
                if (areaConfig && areaConfig.filters && areaConfig.filters.area) {
                    if (areaConfig.filters.area.includes('福岡市') || 
                        areaConfig.filters.area.includes('北九州市') || 
                        areaConfig.filters.area.includes('筑後地区') || 
                        areaConfig.filters.area.includes('筑豊地区') || 
                        areaConfig.filters.area.includes('佐賀')) {
                        area = 'fukuoka'
                    }
                    // 関西エリアの場合
                    else if (areaConfig.filters.area.includes('大阪市') || 
                             areaConfig.filters.area.includes('大阪市外') || 
                             areaConfig.filters.area.includes('京都府') || 
                             areaConfig.filters.area.includes('奈良県') || 
                             areaConfig.filters.area.includes('兵庫県') || 
                             areaConfig.filters.area.includes('和歌山県')) {
                        area = 'kansai'
                    }
                    // 名古屋エリアの場合
                    else if (areaConfig.filters.area.includes('名古屋市') || 
                             areaConfig.filters.area.includes('名古屋市外') || 
                             areaConfig.filters.area.includes('岐阜県') || 
                             areaConfig.filters.area.includes('三重県')) {
                        area = 'nagoya'
                    }
                    // 仙台エリアの場合
                    else if (areaConfig.filters.area.includes('仙台市') || 
                             areaConfig.filters.area.includes('仙台市外') || 
                             areaConfig.filters.area.includes('岩手県') || 
                             areaConfig.filters.area.includes('秋田県') || 
                             areaConfig.filters.area.includes('山形県') || 
                             areaConfig.filters.area.includes('福島県')) {
                        area = 'sendai'
                    }
                    // 札幌エリアの場合
                    else if (areaConfig.filters.area.includes('道央') || 
                             areaConfig.filters.area.includes('道東') || 
                             areaConfig.filters.area.includes('道北') || 
                             areaConfig.filters.area.includes('道南')) {
                        area = 'sapporo'
                    }
                    // 静岡エリアの場合
                    else if (areaConfig.filters.area.includes('中部') || 
                             areaConfig.filters.area.includes('東部') || 
                             areaConfig.filters.area.includes('西部')) {
                        area = 'shizuoka'
                    }
                    // 北部関東エリアの場合
                    else if (areaConfig.filters.area.includes('群馬県') || 
                             areaConfig.filters.area.includes('茨城県') || 
                             areaConfig.filters.area.includes('栃木県')) {
                        area = 'northern_kanto'
                    }
                }
                
                const response = await fetch(`/api/jobs?area=${area}`)
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`)
                }
                
                const data = await response.json()
                
                if (data.status === 'success' || data.status === 'cached') {
                    setJobs(data.jobs || [])
                    setMapping(data.mapping || {
                        areaMapping: {},
                        genreMapping: {},
                        positionMapping: {}
                    })
                } else {
                    throw new Error(data.message || 'Failed to load data')
                }
            } catch (err) {
                console.error('Failed to load jobs:', err)
                setError(err)

                setJobs([])
                setMapping({
                    areaMapping: {},
                    genreMapping: {},
                    positionMapping: {}
                })
            } finally {
                setLoading(false)
            }
        }

        loadJobs()
    }, [areaConfig])

    return { jobs, mapping, loading, error }
}
